// CO - Kits carrossel — abre a modal do kit no lugar de navegar pra PDP.
//
// Quem desenha os seletores dentro da modal é o bloco `conso-kit-montado`,
// renderizado estático pela section. Este arquivo só cuida de abrir, fechar e
// sair do caminho quando o kit entra no carrinho.

(() => {
  if (window.__consoKitsCarrossel) return;
  window.__consoKitsCarrossel = true;

  const abrir = (id) => {
    const modal = document.getElementById(id);
    if (modal && typeof modal.showModal === 'function' && !modal.open) modal.showModal();
  };

  document.addEventListener('click', (evento) => {
    const alvo = evento.target instanceof Element ? evento.target : null;
    if (!alvo) return;

    const gatilho = alvo.closest('[data-kc-abrir]');
    if (gatilho) {
      evento.preventDefault();
      abrir(gatilho.dataset.kcAbrir);
      return;
    }

    const fechar = alvo.closest('[data-kc-fechar]');
    if (fechar) {
      fechar.closest('dialog')?.close();
      return;
    }

    // Clique no backdrop: o <dialog> ocupa a tela toda e a caixa é filha dele,
    // então o alvo só é o próprio dialog quando o clique caiu fora da caixa.
    if (alvo.matches('dialog.kc__modal')) alvo.close();
  });

  // Kit adicionado: a sacola abre por cima (o drawer também é dialog, e dois
  // modais empilhados deixam o de baixo preso no top layer). Fechar aqui devolve
  // a página num estado limpo.
  document.addEventListener('cart:update', (evento) => {
    if (evento.detail?.data?.source !== 'conso-kit-montado') return;

    for (const modal of document.querySelectorAll('dialog.kc__modal[open]')) modal.close();
  });
})();
